import * as Yup from 'yup';
import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import palette from 'src/theme/palette';
import { TableNoData } from 'src/components/NoData';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import Searchbar from '../dashboard/Searchbar';
import { api } from 'src/Api';
import { toast } from 'react-toastify';
import CustomDropdown from 'src/components/CustomDropdown';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';

const InviteModalUserManage = ({ visiable, onClose, data, isEdit, refresh }) => {
  const token = localStorage.getItem('token');

  const [loading, setLoading] = useState(false);
  const [search, setsearch] = useState('');
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [saveLoading, setSaveLoading] = useState(null);

  const [roleList, setRoleList] = useState([]);

  const [projectUserList, setProjectuserList] = useState([]);

  // selectedRoles ko projectUserList load hone ke baad initialize karo
  useEffect(() => {
    if (projectUserList.length > 0) {
      const initialRoles = projectUserList.map((val) => ({
        project_id: val.project_id || val.id,
        role_id: 5 // 👈 default role_id
      }));
      setSelectedRoles(initialRoles);
    }
  }, [projectUserList]);

  useEffect(() => {
    if (search.length == 0 && data?.id) {
      getProjectUser();
    }
  }, [search]);

  useEffect(() => {
    if (data?.id) {
      getProjectUser();
      getRoleData();
    }
  }, [data]);

  function getProjectUser() {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const queryParams = new URLSearchParams();
    queryParams.append('user_id', data?.id);
    search && queryParams.append('search', search);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(`${api.get_user_by_invite}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setProjectuserList(result?.data);
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function getRoleData() {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(api.get_roles, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setRoleList(result?.data);
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {});
  }

  function handleInviteUser(selectedUser, index) {
    if (!selectedUser?.role_id) {
      toast.error('Please select a role first');
      return;
    }
    setSaveLoading(index);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    data?.id && formData.append('user_id', data?.id);
    formData.append('project_id', selectedUser?.project_id);
    formData.append('role_id', selectedUser?.role_id);

    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: myHeaders,
      body: formData
    };

    fetch(api.invite_single_user, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          toast.success(result.message);
          getProjectUser();
          refresh();
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        toast.error(error.error);
        console.log('error', error);
      })
      .finally(() => {
        setSaveLoading(null);
      });
  }

  return (
    <Dialog
      open={visiable}
      onClose={() => {
        onClose();
        setSelectedRoles([]);
      }}
      PaperProps={{
        sx: {
          width: '700px',
          borderRadius: 1,
          maxHeight: '75%'
        }
      }}
      maxWidth="md"
    >
      <DialogTitle sx={{ pb: 0, paddingLeft: 2, paddingRight: 2, paddingTop: 1 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 0
          }}
        >
          <Typography
            sx={{ fontSize: 16, color: palette.primary.titledark, fontFamily: 'poppinsBold' }}
          >
            User Project
          </Typography>
          <IconButton
            onClick={() => {
              onClose();
              setSelectedRoles([]);
            }}
          >
            <CloseIcon style={{ color: palette.primary.disabled, fontSize: 20 }} />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* INVITATIONS */}
      <DialogContent>
        {!loading && (
          <>
            <Grid container mb={3} mt={2}>
              {/* Searchbar */}
              <Grid item xs={12} sm={9} md={10.8}>
                <Searchbar
                  width="98%"
                  value={search}
                  setFunction={(val) => setsearch(val)}
                  className="width_full_property"
                  placeholder="Search..."
                  onEnter={() => {
                    getProjectUser();
                  }}
                />
              </Grid>

              {/* Search Button */}
              <Grid item xs={12} sm={3} md={1}>
                <LoadingButton
                  sx={{ height: 33, borderRadius: 0.7, mr: 3 }}
                  variant="contained"
                  onClick={() => {
                    getProjectUser();
                  }}
                >
                  <Iconify icon="material-symbols:search" sx={{ width: 20, height: 20 }} />
                </LoadingButton>
              </Grid>
            </Grid>

            {projectUserList.map((val, index) => {
              return (
                <Stack
                  key={val.id || index}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1,
                    borderBottom: 1,
                    borderColor: palette.primary.inputborder,
                    pb: 1
                  }}
                >
                  <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                    <Typography
                      sx={{
                        fontSize: 13,
                        color: palette.primary.titledark,
                        fontFamily: 'poppinsSemiBold'
                      }}
                    >
                      {val?.project_name}
                    </Typography>
                  </Box>
                  {val.role ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          color: palette.primary.main,
                          fontFamily: 'poppinsSemiBold',
                          backgroundColor: palette.primary.lighterMain,
                          padding: '1px 15px',
                          borderRadius: 10,
                          letterSpacing: 0.5,
                          mb: 0.5
                        }}
                      >
                        {val?.role?.role_name}
                      </Typography>
                      <Typography
                        sx={{ fontFamily: 'poppinsLight', ml: 1 }}
                        className={
                          (val?.status?.toLowerCase() == 'active' && 'status-green-small') ||
                          (val?.status?.toLowerCase() == 'pending' && 'status-pending-small') ||
                          (val?.status?.toLowerCase() == 'expire' && 'status-red-small')
                        }
                      >
                        {val?.status.toLowerCase() == 'expire' ? 'EXPIRED' : val?.status}
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      <Box sx={{ ml: 3 }}>
                        <Tooltip title="Invite">
                          <span>
                            <LoadingButtonWrapper
                              loading={saveLoading == index}
                              onClick={() => handleInviteUser(selectedRoles[index], index)} // ✅ pass full object
                              variant="contained"
                              sx={{
                                width: saveLoading == index ? 120 : 70,
                                height: 30,
                                fontSize: 10,
                                borderRadius: 0.7,
                                fontFamily: 'poppinsLight',
                                letterSpacing: 0.3,
                                minWidth: 10,
                                paddingRight: 0,
                                paddingLeft: 0,
                                paddingTop: 0,
                                paddingBottom: 0,
                                mr: 0.5,
                                transition:
                                  'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease'
                              }}
                              title="Invite"
                            />
                          </span>
                        </Tooltip>
                      </Box>
                      <Box sx={{ minWidth: 150 }}>
                        <CustomDropdown
                          height={34}
                          marginBottom={'0rem'}
                          name="role"
                          value={selectedRoles[index]?.role_id || ''} // ✅ ab yahan default 5 set rahega
                          onChange={(e) => {
                            const roleId = e.target.value;
                            setSelectedRoles((prev) => {
                              const updated = [...prev];
                              updated[index] = {
                                project_id: val.project_id || val.id,
                                role_id: roleId
                              };
                              return updated;
                            });
                          }}
                          options={roleList.map((role) => ({
                            value: role.id,
                            label: role.role_name
                          }))}
                          placeholder="Select role"
                        />
                      </Box>
                    </>
                  )}
                </Stack>
              );
            })}
          </>
        )}

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10.4 }}>
            <CircularProgress sx={{ color: palette.primary.main }} size={25} />
          </Box>
        )}

        {/* empty list */}
        {projectUserList.length == 0 && !loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <TableNoData title="No Invitations" sx={{ padding: 5, borderBottom: 0 }} />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};
export default InviteModalUserManage;
